<template>
    <div class="row no-gutters ">
        <div class="col-12">
            <div class="row no-gutters justify-content-center card-changes-header w-100">
                <div class="col-12 text statistics-title-text text-center">
                    <span>CARD CHANGES</span>
                </div>
                <span class="col-12 text statistics-title-subtitle-text text-center">Greyville - Sunday 14/10/2018</span>
            </div>
            <div class="row no-gutters justify-content-center card-changes-body">
                <div class="col-12 my-3">
                    <div class="row no-gutters justify-content-center">
                        <div class="col-10 col-md-4">
                            <dropdown :dropdownConfig="dropdownConfig"></dropdown>
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md-4 card-changes-subheader text-center mb-2">
                    <span class="text">CARD SCRATCHINGS</span>
                </div>
                <div class="col-12">
                    <div class="row no-gutters justify-content-space-evenly team-details-table">
                        <div style="position: relative;" class="col-12 px-1">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">RACE</th>
                                        <th scope="col">HORSE</th>
                                        <th scope="col">NAME</th>
                                        <th scope="col">COMMENT</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td scope="row">5</td>
                                        <td scope="row">American Hustle</td>
                                        <td scope="row">Under Vet Treatment</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">2</td>
                                        <td scope="row">4</td>
                                        <td scope="row">Solicitor General</td>
                                        <td scope="row">Abnormal Blood Count</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td scope="row">3</td>
                                        <td scope="row">All Night Long</td>
                                        <td scope="row">Abscess Near Fore</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">2</td>
                                        <td scope="row">1</td>
                                        <td scope="row">Damaraland (IRE)</td>
                                        <td scope="row">Lame Off Fore</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">8</td>
                                        <td scope="row">7</td>
                                        <td scope="row">Kobus</td>
                                        <td scope="row">Abscess Near Fore</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--<finishing-position-pop-up :offsetLeft="offsetLeft" :offsetTop="offsetTop"-->
                            <!--:onPositionClickedCallback="onFormGridOpened"-->
                            <!--v-if="isFinishPositionPopupOpen"></finishing-position-pop-up>-->
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md-4 card-changes-subheader text-center mb-2">
                    <span class="text">JOCKEY CHANGES</span>
                </div>
                <div class="col-12">
                    <div class="row no-gutters justify-content-space-evenly team-details-table">
                        <div style="position: relative;" class="col-12 px-1">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">RACE</th>
                                        <th scope="col">HORSE</th>
                                        <th scope="col">NAME</th>
                                        <th scope="col">COMMENT</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td scope="row">3</td>
                                        <td scope="row">10</td>
                                        <td scope="row">Settlement Day</td>
                                        <td scope="row">S Fortune</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">6</td>
                                        <td scope="row">9</td>
                                        <td scope="row">Steffi's Graft</td>
                                        <td scope="row">K Zechner (+0.5kg)</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">8</td>
                                        <td scope="row">2</td>
                                        <td scope="row">Fire Horse</td>
                                        <td scope="row">C Maujean</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">8</td>
                                        <td scope="row">8</td>
                                        <td scope="row">Rule The World</td>
                                        <td scope="row">* T Juglall (-4.0kg)</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--<finishing-position-pop-up :offsetLeft="offsetLeft" :offsetTop="offsetTop"-->
                            <!--:onPositionClickedCallback="onFormGridOpened"-->
                            <!--v-if="isFinishPositionPopupOpen"></finishing-position-pop-up>-->
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md-4 card-changes-subheader text-center mb-2">
                    <span class="text">OTHER CHANGES</span>
                </div>
                <div class="col-12">
                    <div class="row no-gutters justify-content-space-evenly team-details-table">
                        <div style="position: relative;" class="col-12 px-1">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">DETAILS</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td scope="row">Not Riding: J Penny (medically indisposed)</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--<finishing-position-pop-up :offsetLeft="offsetLeft" :offsetTop="offsetTop"-->
                            <!--:onPositionClickedCallback="onFormGridOpened"-->
                            <!--v-if="isFinishPositionPopupOpen"></finishing-position-pop-up>-->
                        </div>
                    </div>
                </div>
                <div class="col-6 col-md-4 card-changes-subheader text-center mb-2">
                    <span class="text">EQUIPMENT CHANGES</span>
                </div>
                <div class="col-12">
                    <div class="row no-gutters justify-content-space-evenly team-details-table">
                        <div style="position: relative;" class="col-12 px-1">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class="thead-dark">
                                    <tr>
                                        <th scope="col">RACE</th>
                                        <th scope="col">HORSE</th>
                                        <th scope="col">NAME</th>
                                        <th scope="col">COMMENT</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td scope="row">2</td>
                                        <td scope="row">The Greek Soldier</td>
                                        <td scope="row">Alumites On</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td scope="row">4</td>
                                        <td scope="row">Ferrari's Moon</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td scope="row">4</td>
                                        <td scope="row">Ferrari's Moon</td>
                                        <td scope="row">Blinkers Off</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td scope="row">6</td>
                                        <td scope="row">Tibetan Rouge</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td scope="row">7</td>
                                        <td scope="row">Piazza Del Campo</td>
                                        <td scope="row">Tongue Tie On</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">2</td>
                                        <td scope="row">2</td>
                                        <td scope="row">Keep It Green</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">2</td>
                                        <td scope="row">2</td>
                                        <td scope="row">Keep It Green</td>
                                        <td scope="row">Blinkers On</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">2</td>
                                        <td scope="row">7</td>
                                        <td scope="row">Espressivo</td>
                                        <td scope="row">Blinkers and Pacifiers On</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">3</td>
                                        <td scope="row">7</td>
                                        <td scope="row">Nahoon River</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">3</td>
                                        <td scope="row">10</td>
                                        <td scope="row">Settlement Day</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">4</td>
                                        <td scope="row">2</td>
                                        <td scope="row">Lucky Lulu</td>
                                        <td scope="row">Blinkers On</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">4</td>
                                        <td scope="row">4</td>
                                        <td scope="row">Rocksette</td>
                                        <td scope="row">Tongue Tie On</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">4</td>
                                        <td scope="row">7</td>
                                        <td scope="row">Onesie</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">5</td>
                                        <td scope="row">6</td>
                                        <td scope="row">Unexpected View</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">6</td>
                                        <td scope="row">9</td>
                                        <td scope="row">Steffi's Graft</td>
                                        <td scope="row">Blinkers Off</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">7</td>
                                        <td scope="row">3</td>
                                        <td scope="row">Cowgirlinthesand</td>
                                        <td scope="row">Tongue Tie On</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">7</td>
                                        <td scope="row">7</td>
                                        <td scope="row">It's A Girl</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    <tr>
                                        <td scope="row">8</td>
                                        <td scope="row">1</td>
                                        <td scope="row">Pen-Chan</td>
                                        <td scope="row">Alumites Front On, Unshod behind</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!--<finishing-position-pop-up :offsetLeft="offsetLeft" :offsetTop="offsetTop"-->
                            <!--:onPositionClickedCallback="onFormGridOpened"-->
                            <!--v-if="isFinishPositionPopupOpen"></finishing-position-pop-up>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropdown from '../components/Dropdown';

    export default {
        name: 'CardChanges',
        components: {Dropdown},
        data: function () {
            return {
                dropdownConfig: {
                    placeHolder: 'Select Course',
                    dropDownOptions: [
                        {
                            name: 'VAAL',
                            onClickCallback: () => {}
                        },
                        {
                            name: 'FAIRVIEW',
                            onClickCallback: () => {}
                        },
                        {
                            name: 'GREYVILLE',
                            onClickCallback: () => {}
                        }
                    ]
                }
            };
        },
        props: {
        },
        methods: {
            getImage(imagePath, fileType = 'svg') {
                return require('../assets/images/' + imagePath + '.' + fileType);
            }
        },
        mounted: function () {
        }
    }
</script>

<style scoped>
    .card-changes-header {
        background-color: #000000;
        padding: 1.5rem 0;
    }

    .card-changes-body {
        background-color: #FFFFFF;
    }

    .card-changes-subheader {
        background-color: #000000;
        font-size: 1rem;
        padding: 0.6rem 0;
        margin-top: 1rem;
        opacity: 0.8;
    }

    th {
        padding-top: 0.5rem !important;
        padding-bottom: 0.5rem !important;
    }

    .table td {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
        white-space: normal;
        word-wrap: break-word;
    }

    table {
        table-layout: fixed;
    }

    .statistics-title-text {
        font-size: 1.8rem;
    }

    .statistics-title-subtitle-text {
        font-size: 1.2rem;
    }

    .highlighted-table-cell {
        background-color: #f2f2f2;
    }

    .table-responsive {
        border: 1px solid #7c7c7c !important;
        margin-bottom: 0.5rem !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    .team-details-table {
        margin-top: 0.6rem;
    }

    .dropdown-button-item {
        background-color: #000000;
        font-size: 1rem;
        opacity: 0.8;
        color: #FFFFFF;
    }

    @media (min-width: 1200px) {
        .card-changes-subheader {
            font-size: 1.2rem;
        }

        .table td {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
        }
    }
</style>
